/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const CreateAffiliateDetails = MatxLoadable({
  loader: () => import("../views/affiliates/details"),
});

const CreateAffiliateList = MatxLoadable({
  loader: () => import("../views/affiliates/list"),
});

const affiliateRoutes = [
  {
    path: "/affiliate/dashboard",
    component: CreateAffiliateList,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/affiliate/list/:id",
    component: CreateAffiliateDetails,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/affiliate/list",
    component: CreateAffiliateList,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default affiliateRoutes;
